import type { LogisticPivotGroupDisplayMode } from '../models/LogisticPivot';

export function parseGroupDisplayParam(
  raw: string | undefined | null,
  fallback: LogisticPivotGroupDisplayMode = 'hierarchy'
): LogisticPivotGroupDisplayMode {
  if (raw === 'columns' || raw === 'hierarchy') return raw;
  return fallback;
}

export function serializeGroupDisplayParam(mode: LogisticPivotGroupDisplayMode): string {
  return mode;
}
